import { render } from "./LinkUserPortal.vue?vue&type=template&id=d09439f8"
import script from "./LinkUserPortal.vue?vue&type=script&lang=js"
export * from "./LinkUserPortal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\deploy\\fire-conference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__